// Central SVG mandala/lotus decorations used across the site.
import React from "react";

export const Mandala = ({ className = "", stroke = "#D4AF37" }) => (
    <svg
        aria-hidden="true"
        viewBox="0 0 200 200"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" stroke={stroke} strokeWidth="0.7">
            <circle cx="100" cy="100" r="98" />
            <circle cx="100" cy="100" r="82" />
            <circle cx="100" cy="100" r="66" />
            <circle cx="100" cy="100" r="50" />
            <circle cx="100" cy="100" r="34" />
            <circle cx="100" cy="100" r="18" />
            {Array.from({ length: 24 }).map((_, i) => {
                const a = (i * Math.PI) / 12;
                const x1 = 100 + Math.cos(a) * 18;
                const y1 = 100 + Math.sin(a) * 18;
                const x2 = 100 + Math.cos(a) * 98;
                const y2 = 100 + Math.sin(a) * 98;
                return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} />;
            })}
            {Array.from({ length: 12 }).map((_, i) => {
                const a = (i * Math.PI) / 6;
                const cx = 100 + Math.cos(a) * 66;
                const cy = 100 + Math.sin(a) * 66;
                return <circle key={`p-${i}`} cx={cx} cy={cy} r="6" />;
            })}
            {Array.from({ length: 8 }).map((_, i) => {
                const a = (i * Math.PI) / 4;
                const cx = 100 + Math.cos(a) * 40;
                const cy = 100 + Math.sin(a) * 40;
                return (
                    <ellipse
                        key={`l-${i}`}
                        cx={cx}
                        cy={cy}
                        rx="4"
                        ry="10"
                        transform={`rotate(${(i * 45)} ${cx} ${cy})`}
                    />
                );
            })}
        </g>
    </svg>
);

export const Lotus = ({ className = "", fill = "#D4AF37" }) => (
    <svg
        aria-hidden="true"
        viewBox="0 0 64 64"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill={fill} fillOpacity="0.9">
            <path d="M32 8c2 8 8 14 8 22-4-2-6-6-8-10-2 4-4 8-8 10 0-8 6-14 8-22z" />
            <path d="M12 26c6 2 12 6 14 12-6 0-12-4-14-12z" />
            <path d="M52 26c-2 8-8 12-14 12 2-6 8-10 14-12z" />
            <path d="M8 40c8 0 16 4 20 12-8 0-16-4-20-12z" />
            <path d="M56 40c-4 8-12 12-20 12 4-8 12-12 20-12z" />
            <path d="M20 42c4 6 8 10 12 12 4-2 8-6 12-12-4 2-8 4-12 4s-8-2-12-4z" />
        </g>
    </svg>
);

export const OmSymbol = ({ className = "", color = "#D4AF37" }) => (
    <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        fill={color}
    >
        <path d="M6.5 12.5c0-1.6 1.3-2.9 3-2.9 1.7 0 2.6 1 2.6 2.3 0 1.9-2 2.5-3.4 3-1 .3-1.4.5-1.4 1s.4.8 1.1.8c.9 0 1.6-.5 2-1.3.3 1.6 1.5 2.8 3.2 2.8 2.2 0 3.8-1.6 3.8-3.8 0-1.4-.6-2.5-1.5-3.2.4-.2.7-.6.7-1.1 0-.7-.6-1.2-1.4-1.2-.6 0-1 .3-1.3.7-.3-.4-.7-.6-1.2-.6-.9 0-1.5.7-1.5 1.6 0 .3.1.5.2.7-1.4-.5-3-.1-4 1-.7.8-1 1.8-1 2.7 0 .2 0 .5.1.7-.3-.2-.6-.4-1-.4zM18.5 5c0 .8-.7 1.5-1.5 1.5S15.5 5.8 15.5 5 16.2 3.5 17 3.5 18.5 4.2 18.5 5z" />
    </svg>
);
